import React, {useEffect, useState} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import PersonTodoList from "../../ClientRetention/PersonTodoList";
import {getPersonTodosHistory} from "../../../../API/clientRetention";

function TodoHistoryOverviewTab(props) {
    const {person} = props;
    const [personTodos, setPersonTodos] = useState([]);

    useEffect(() => {
        fetchTodos();
    }, [person?.person_id]);

    const fetchTodos = () => {
        if (person) {
            getPersonTodosHistory(person.person_id, 1).then((res) => {
                if (res?.data) {
                    setPersonTodos(res.data.data);
                }
            });
        }
    }

    return (
        <>
            <Grid container sx={{marginTop: "20px"}}>
                <Grid item xs={9}>
                    <Typography
                        variant='span'
                        component='span'
                        sx={{fontWeight: 'bold'}}>
                        Todo Items
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography
                        variant='span'
                        component='span'
                        sx={{fontWeight: 'bold'}}>
                        Due Date
                    </Typography>
                </Grid>
            </Grid>
            <PersonTodoList todos={personTodos} type='history'  person={person}/>
        </>
    );
}

export default TodoHistoryOverviewTab;